module.exports = __webpack_public_path__ + "img/pad_icon_4.f87e4d96.png";